import NewSlideshow from '../../classes/NewSlideshow';
import SimpleBar from 'simplebar';

export const initSlider = ( slider ) => {
	const slidersAll = Array.from( document.querySelectorAll( 'div.furniture-box>div.new-slider' ) );
	const sliderInfoBoxes = Array.from( document.querySelectorAll( '.furniture-info' ) );

	slidersAll.forEach( ( box ) => {
		if ( box.querySelectorAll( '.slides' ).length > 1 ) {
			box.querySelectorAll( '.slides' ).forEach( ( el ) => {
				el.classList.add( 'not-current' );
			} );
			const firstBox = Array.from( box.querySelectorAll( '.slides' ) );
			if ( firstBox[0].classList.contains( 'not-current' ) ) {
				firstBox[0].classList.remove( 'not-current' );
			}
		}
	} );

	document.querySelectorAll('.custom-scroll').forEach(el => {
		new SimpleBar(el,{
			scrollbarMinSize: 134,
			scrollbarMaxSize: 134,
		});
	});

	

	const ButtonPlace = () => {
		const buttonsNav = document.querySelectorAll( 'ul.nav-buttons' );

		const imageWidth = Array.from( document.querySelector( '.slides-active>li>.image-container>figure' ) ).clientWidth;

		buttonsNav.forEach( ( el ) => {
			el.style.opacity = '1';
			el.style.left = `${imageWidth}px`;
		} );
	};

	const btnInit = () => {
		addEventListener( 'resize', ButtonPlace );
		setTimeout( () => {
			ButtonPlace();
		}, 100 );

	};

	btnInit();

	const sliderInstance = new NewSlideshow( {
		element: slider,
		loop: false,
		switchCallback: btnInit,
	} );

	sliderInstance.init();

	return () => {
		sliderInstance.updateSizes();
	};
};
